package dev.bitspittle.droidconSf24.pages.sections.intro

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import dev.bitspittle.droidconSf24.components.widgets.*
import dev.bitspittle.droidconSf24.components.examples.*
import dev.bitspittle.droidconSf24.utilities.dataId
import dev.bitspittle.droidconSf24.utilities.attr
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.icons.fa.IconStyle as FaIconStyle
import com.varabyte.kobweb.silk.components.icons.mdi.*
import com.varabyte.kobweb.silk.components.icons.mdi.IconStyle as MdiIconStyle
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.fr

@Page
@Composable
fun CautionPage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("sections/intro/Caution.md", mapOf("follows" to listOf("ExampleSites")))) {
        dev.bitspittle.droidconSf24.components.layouts.SectionLayout {
            org.jetbrains.compose.web.dom.H2(attrs = { id("caution") }) {
                org.jetbrains.compose.web.dom.Text("⚠️ Caution ⚠️")
            }
            org.jetbrains.compose.web.dom.Ul {
                org.jetbrains.compose.web.dom.Li {
                    com.varabyte.kobweb.compose.dom.GenericTag("span", "style=\"color:orange\"") {
                        org.jetbrains.compose.web.dom.B {
                            org.jetbrains.compose.web.dom.Text("Not 1.0 yet!")
                        }
                    }
                }
                org.jetbrains.compose.web.dom.Li {
                    Kobweb()
                    org.jetbrains.compose.web.dom.Text(" is ")
                    org.jetbrains.compose.web.dom.Em {
                        org.jetbrains.compose.web.dom.Text("not")
                    }
                    org.jetbrains.compose.web.dom.Text(" a shared UI framework")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("Still early days")
                }
            }
            SpeakerNotes {
                org.jetbrains.compose.web.dom.Ul {
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("Maybe mention this talk is only going to be building blocks")
                    }
                }
            }
        }
    }
}
